import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface AlertProp {
  message: string;
  type?: "success" | "error" | "info" | "warning";
}

const Alert = ({ message, type = "success" }: AlertProp): void => {
  const options: any = {
    position: "top-right",
    hideAfter: 5, // seconds
    theme: "light",
  };
  toast[type](message, options);
};

export default Alert;
